import { Md, Py } from "components/Lang.js";
import React from 'react';
export default {
  Md,
  Py,
  React
};